import React from 'react';
import ImgIconComp from '../../components/imgcomp';
import { useTranslation, Trans } from 'react-i18next';

const EmptyBoardComp = (props:any) => {
    const { t } = useTranslation();
    return (
        <div className="sharedEmptyMsg">
          <div>
            {" "}
            <ImgIconComp id="board_empty" width="350" height="175" />
          </div>
          <div className="emptyBoardImage">{t("You don’t have any boards yet!")}</div>
          <Trans
            i18nKey="board.empty.description"
            components={{
              Description: <div className="emptyBoardDesc" />,
              DescriptionData: <div className="emptyBoardDescdata" />
            }}
          />
        </div>
      );
}

export default EmptyBoardComp;